/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { Box, Text } from '@towersystems/towersystems-design-system';
import { map, size, compact, round } from 'lodash';
import { Table } from 'antd';
import { connect } from 'react-redux';
import DropdownLink from 'components/dropdown-link';

/**
 * Internal dependencies
 */
import { startMappingSalesTypes, deleteMappingSalesTypes } from 'state/ui/sales-types-modal/actions';
import {successNotice} from 'state/notices/actions';

const SalesTypesListTable = ({ items, requestingConnectionSalesTypes, connectionSalesTypes, connectionId, requestItems, requesting, ...props }) => {

    const dataSource = map(connectionSalesTypes, (r) => {
        return r;
    });

    const columns = [
        {
            title: 'Web Payment Type',
            key: 'web_payment_type',
            dataIndex: 'web_payment_type',
            render: (a) => {
                return <Text>{a}</Text>;
            },
        },
        {
            title: 'Retailer Sales Type',
            key: 'retailer_sales_type',
            dataIndex: 'retailer_sales_type',
            render: (a) => {
                return <Text>{a}</Text>;
            },
        },
        {
            title: 'Retailer Payment Method',
            key: 'retailer_payment_type',
            dataIndex: 'retailer_payment_type',
            render: (a) => {
                return <Text>{a}</Text>;
            },
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (a) => {
                return (
                    (a.retailer_sales_type != '' || a.retailer_payment_type !='') ?
                    <DropdownLink
                        title='Actions'
                        items={compact([
                            {
                                label: 'Edit',
                                key: 'edit_data',
                                onClick: () => props.startMappingSalesTypes(a.id),
                            },
                            {
                                label: 'Delete',
                                key: 'delete_data',
                                onClick: () => {
                                    props.deleteMappingSalesTypes(a.id); 
                                    props.successNotice("Deleted");
                                },
                            },
                        ])}
                    /> : 
                    <DropdownLink
                        title='Actions'
                        items={compact([
                            {
                                label: 'Add',
                                key: 'add_data',
                                onClick: () => props.startMappingSalesTypes(null, { connection: connectionId, connection: connectionId, web_payment_type: a.web_payment_type, web_payment_code: a.web_payment_code }),
                            },
                        ])}
                    />
                )
            },
        },
    ];

    return (
        <Box>
            <Table
                columns={columns}
                dataSource={dataSource}
                pagination={false}
                loading={requestingConnectionSalesTypes}
                scroll={{ x: 'max-content' }}
            />
        </Box>
    );
};

export default connect(null, {
    startMappingSalesTypes,
    deleteMappingSalesTypes,
    successNotice,
})(SalesTypesListTable);
